import { createSelector } from '@reduxjs/toolkit';
import selfSelector from '../self';

const filtersSelector = createSelector(selfSelector, (rejectsReport) => rejectsReport.filter);

export default filtersSelector;
